import { ReactNode } from 'react'

export const InfoRow = ({
  icon,
  label,
  value,
}: {
  icon: ReactNode
  label: string
  value: string
}): JSX.Element => (
  <div className="flex items-center justify-between border-b border-gray-200 py-2 last:border-0 dark:border-gray-700">
    <div className="flex items-center gap-2">
      {icon}
      <span className="text-gray-600 dark:text-gray-400">{label}:</span>
    </div>
    <span className="font-medium text-gray-800 dark:text-gray-100">
      {value}
    </span>
  </div>
)
